import styled from 'styled-components/macro';

export const RoundProfileImage = styled.img`
  clip-path: circle();
  object-fit: ${({ isChrome }) => (isChrome ? 'fill' : 'cover')};
`;
